import React from "react";
import { Toaster } from "react-hot-toast";
import { ThemeProvider } from "../../bookingapp/contexts/ThemeContext.jsx";
import { AuthProvider } from "../../bookingapp/contexts/AuthContext.jsx";
import BookingAppRoutes from "../../bookingapp/BookingAppRoutes.jsx";
import "../../bookingapp/booking-shell.css";

export default function BookingDemo() {
  return (
    <div className="booking-app-root bg-gray-900 text-gray-100 antialiased">
      <ThemeProvider>
        <AuthProvider>
          <BookingAppRoutes />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: "#1F2937",
                color: "#F9FAFB",
                borderRadius: "12px",
                padding: "16px",
              },
              success: {
                iconTheme: { primary: "#10B981", secondary: "#F9FAFB" },
              },
              error: {
                iconTheme: { primary: "#EF4444", secondary: "#F9FAFB" },
              },
            }}
          />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}
